import React from 'react';
import bemClass from '@upsales/components/Utils/bemClass';
import './SignalIndicators.scss';
import AISignals from 'App/resources/Model/AISignals';
import { Flex } from '@upsales/components';

interface SignalIndicatorsProps {
	signals?: AISignals | null;
	className?: string;
}

const SignalIndicators: React.FC<SignalIndicatorsProps> = ({ signals, className }) => {
	const classes = new bemClass('SignalIndicators').add(className);

	// validate summary length because we dont show sentiment if the summary is too short
	if (!signals || (!signals.positive && !signals.negative) || (signals.summary?.length || 0) <= 10) {
		return null;
	}
	return (
		<Flex gap="u2" alignItems="center">
			{signals.positive ? (
				<div className={classes.elem('indicator').mod('positive').b()}>{`+${signals.positive}`}</div>
			) : null}
			{signals.negative ? (
				<div className={classes.elem('indicator').mod('negative').b()}>{`-${signals.negative}`}</div>
			) : null}
		</Flex>
	);
};

export default SignalIndicators;
